import React from "react";
import propTypes from "prop-types";
import { Header, Form, Input } from "semantic-ui-react";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { GET } from "../../frameworks/HttpClient";
import { URL_COMMON } from "../../constances";
import ChemicalInputForm from "./ChemicalInputForm";

let targetId = 1;
const LabAdjustInput = React.forwardRef((props, ref) => {
	const [others, setOthers] = React.useState([]);
	const [trigger, setTrigger] = React.useState(false);
	const [options, setOptions] = React.useState([]);
	const chemicalRef = React.useRef([]);

	const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: { 
			nh3: props.initialModel ? props.initialModel.nh3 : ""
		},
    validationSchema: Yup.object().shape({
			nh3: Yup.number().notRequired()
		}),
    onSubmit: props.onSubmit,
  });

	const fetchOptions = async () => {
		try {
			const response = await GET(`${URL_COMMON.CHEMICAL}`);
			setOptions(
        response.data.map(item => {
          return {
            key: item.id, 
            value: item.name, 
            text: item.name
          }
        })
      );
		} catch (error) {}
	}
	
	const handleAddChemical = () => {
		targetId = targetId + 1;
		setOthers([
			...others,
			{id: targetId, chemical: "", amount: ""}
		])
	}

	const handleDeleteChemical = (data) => {
		let myList = others;
		let index = 0;
		for (let i = 0; i < myList.length; i++) {
			if (myList[i].id === data.id) {
				index = i;
				break;
			}
		}
		
		if (index > 0) {
			myList.splice(index, 1);
			setOthers(myList);
			setTrigger(!trigger);
		}
	}

	React.useImperativeHandle(ref, () => ({ 
		formik,
		getOthers: () => {
			let list = []
			for (let index in others) {
				let value = chemicalRef.current[index].getValue()
				if (value.chemical && (value.amount > 0)) {
					list.push(value);
				}
			}
			return list;
		}
	 }));

	React.useEffect(() => {
		if (props.initialOthersModal 
			&& (props.initialOthersModal.length > 0)) {
				targetId = props.initialOthersModal.length;
				setOthers(props.initialOthersModal);
		} else {
			targetId = 1;
			setOthers([{id: 1, chemical: "", amount: ""}]);
		}

		formik.resetForm();
		fetchOptions();
	}, [])

	return (
		<div style={{...props.style}}>
			<Header as={"h3"} style={{marginLeft: 24}}>สารเคมีที่ต้องการเติมเพิ่ม</Header>
			<Form style={{textAlign: "right"}}>
				<Form.Group widths={"2"}>
					<Form.Field 
						style={{width: "55%"}}
						inline
						readOnly={props.readOnly}
						label={"NH3"}
						control={Input}
						placeholder={"0"} 
						type={"text"}
						name={"nh3"}
						error={formik.errors.nh3}
						value={formik.values.nh3}
						onChange={formik.handleChange}
					/>
				</Form.Group>

				{/* <ChemicalInput /> */}
				{others.map((data, index) => {
					return (
						<ChemicalInputForm
							ref={(el) => (chemicalRef.current[index] = el)}
							key={data.id} 
							readOnly={props.readOnly}
							options={options} 
							data={data} 
							canDelete={(index === 0) ? false : true}
							onAdd={handleAddChemical} 
							onDelete={handleDeleteChemical}
						/>
					)
				})}
			</Form>
		</div>
	)
});

LabAdjustInput.defaultProps = {
	style: null,
	readOnly: false,
	initialModel: null,
	initialOthersModal: [],
}

LabAdjustInput.propTypes = {
	style: propTypes.object,
	readOnly: propTypes.bool,
	initialModel: propTypes.object,
	initialOthersModal: propTypes.array,
}

export default LabAdjustInput;